<script lang="ts">
	import Breadcrumb from '../../components/Breadcrumb.svelte';
	import ScooterDetailNavigator from '../../components/ScooterDetailNavigator.svelte';
	import CategoryList from './CategoryList.svelte';
	import { scooterStorage } from '../../stores/preferences';
	import { _CategoriesEnum } from '$lib/utils/Enums';
	import OurAdvantages from '../(components)/OurAdvantages.svelte';
	import {scooterLdJson} from "$lib/helpers/ldJsonHelper";

	export let data;
	export let selectedUsed = false;

	scooterStorage.set({
		url: data?.scooter?.url,
		producer: data?.scooter?.producer,
		name: data?.scooter?.name,
		model: data?.scooter?.model,
		hasArticles: data?.scooter?.has_articles,
		hasGraphs: data?.scooter?.has_graphs,
		ccm: data?.scooter?.ccm,
		image: data.scooter.main_image_new.url_medium
	});
</script>

<svelte:head>
	<title>Díly na skútr {data?.scooter?.producer} {data?.scooter?.name}, {data.scooter?.ccm !== "0" ? data.scooter?.ccm + " ccm" : "elektro"}, {data?.scooter?.years ?? ""}</title>
	<meta name="description" content="Široká nabídka náhradních dílů skladem. Rychlé dodání a díly přesně pasující na skútr {data?.scooter?.producer} {data?.scooter?.name}, {data.scooter?.ccm !== '0' ? data.scooter?.ccm + ' ccm' : 'elektro'}, {data?.scooter?.years !== undefined? data.scooter?.years: ''}"/>
	<link rel="canonical" href={`https://www.scootland.cz/skutr-${data?.scooter?.url}/`} />
	<meta name="keywords" content="Skútr {data?.scooter?.producer} {data?.scooter?.name}, {data.scooter?.ccm !== '0' ? data.scooter?.ccm + ' ccm' : 'elektro'} náhradní díly, použité díly, originální díly, součástky, díly, výměna,{data?.scooter?.years !== undefined ? data.scooter?.years : ''}"/>
	<meta property="og:title" content="Díly na skútr {data?.scooter?.producer} {data?.scooter?.name}, {data.scooter?.ccm !== "0" ? data.scooter?.ccm + " ccm" : "elektro"}, {data?.scooter?.years ?? ""}" />
	<meta property="og:description" content="Široká nabídka náhradních dílů skladem. Rychlé dodání a díly přesně pasující na skútr {data?.scooter?.producer} {data?.scooter?.name}, {data.scooter?.ccm !== '0' ? data.scooter?.ccm + ' ccm' : 'elektro'}, {data?.scooter?.years !== undefined? data.scooter?.years: ''}"/>
	<meta property="og:image" content={data?.scooter?.main_image?.url_medium} />
	<meta property="og:type" content="website" />
	<meta property="og:url" content={`https://www.scootland.cz/skutr-${data?.scooter?.url}/`}/>
	<meta property="og:suite_name" content="Scootland"/>
	<meta property="og:type" content="website" />

	<!-- JSON-LD script -->
	{@html `<script type="application/ld+json">${JSON.stringify(scooterLdJson(data),)}</script>`}
</svelte:head>

<Breadcrumb
	breadcrumbs={[
		{ name: 'Díly na konkrétní skútr', link: '/skutry' },
		{ name: data.scooter.producer, link: '/skutry/' + data.scooter.producer },
		{
			name: data?.scooter?.ccm !== '0' ? data?.scooter?.ccm + " ccm" : "elektro",
			link: '/skutry/' + data.scooter.producer + '/' + data.scooter.ccm
		},
		{ name: data.scooter.model, link: 'skutr-' + data.slug }
	]}
/>

<ScooterDetailNavigator selected="home" />

<section class="container mx-auto mb-24 mt-6 px-2.5 md:mt-10 md:px-0">
	<div class="mx-auto mb-8 flex w-full">
		<button
			class:hidden={!data.hasNewArticles}
			on:click={() => (selectedUsed = false)}
			class="inline-block w-1/2 p-4 px-8 transition-all"
			class:bg-footer={!selectedUsed}
			class:text-white={!selectedUsed}
			class:bg-gray-300={selectedUsed}
			class:text-black={selectedUsed}
			class:hover:text-white={selectedUsed}
			class:hover:bg-footer={selectedUsed}
		>
			<h1>Nové náhradní díly</h1>
		</button>
		<button
			class:hidden={!data.hasUsedArticles}
			on:click={() => (selectedUsed = true)}
			class="inline-block w-1/2 p-4 px-8 transition-all"
			class:bg-footer={selectedUsed}
			class:text-white={selectedUsed}
			class:bg-gray-300={!selectedUsed}
			class:text-black={!selectedUsed}
			class:hover:text-white={!selectedUsed}
			class:hover:bg-footer={!selectedUsed}
		>
		     <h1>Použité náhradní díly</h1>
		</button>
	</div>

	<div class="rozkresy:hover flex flex-col gap-y-6 sm:grid sm:grid-cols-2 sm:gap-7 lg:grid-cols-3">
		{#if selectedUsed}
			<CategoryList categories={data.categories_used} categoryType={_CategoriesEnum.used} 
						  selected_scooter={data?.scooter} />
		{:else}
			<CategoryList categories={data.categories} categoryType={_CategoriesEnum.new} 
						  selected_scooter={data.scooter}/>
		{/if}
	</div>
</section>

<OurAdvantages class="container mx-auto border-t-2 border-gray-concrete" />
